import React, { useState, useRef, useEffect } from "react";
import "../../../assets/css/style.css";

interface LanguageSelectProps {
  value: string;
  onChange: (lang: string) => void;
  className?:string
}

const LanguageSelect: React.FC<LanguageSelectProps> = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (e: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="lang-select" ref={dropdownRef}>
      <div className="lang-select__selected" onClick={() => setIsOpen(!isOpen)}>
        {value.toUpperCase()}
        <span className="arrow">&#9662;</span>
      </div>
      {isOpen && (
        <ul className="lang-select__options">
          <li
            onClick={() => {
              onChange("az");
              setIsOpen(false);
            }}
          >
            AZ
          </li>
          <li
            onClick={() => {
              onChange("en");
              setIsOpen(false);
            }}
          >
            EN
          </li>
        </ul>
      )}
    </div>
  );
};

export default LanguageSelect;
